export let getApiLink = ( val ) => {
    return window.AppConfig ? window.AppConfig.apiLink : window.location.protocol + '//' + window.location.host + "/API" ;
    // return 'https://api-grenke-kalkulator.norddigital.com';
}